//@flow
/* Package JSON Import will be here */
import axios from "axios";
/* Package JSON Import will be here */

/* Project Import will be here */
import { loadState } from "app/localStorage";
import querystring from "querystring";
import Constants from "utilities/appConstants";
import { dispatchInstance } from "reducers/common/appSettings";
import { handleNoAppData, handleAppForceLogout } from "reducers/common";
/* Project Import will be here */

/* Const,Let & Var will be here */
export const dmsSecurityTokenKey = "security_token_key";
const { dmsServiceApiUrl } = window;
let isSessionExpired = false;
/* Const,Let & Var will be here */

/* Generic Request model */
export type IRequest = {
    subUrl: string,
    method?: string,
    data?: object,
    params?: object,
    headers?: object
};

/* Generic HTTP Post method */
export const post = (request, needToken = true) => {
    return commonFetch({ needToken, ...request });
};

/* Generic AXIOS method to make HTTP request */
const commonFetch = (request: IRequest) => {
    const { subUrl, needToken, data = {} } = request;
    const requestUrl = `${dmsServiceApiUrl}${subUrl}`;
    const commonHeaders = getCommonHeaders(needToken)
    const localState = loadState();

    /* Handle request for not need token */
    if (!needToken) {
        return axios.post(requestUrl,
            querystring.stringify({
                ...data
            }),
            {
                headers: { ...commonHeaders }
            }).then((response) => {
                if (handleTokenResponseStatus(response))
                    return Promise.resolve(response);
                else
                    return Promise.reject(response);
            });
    }
    else if (needToken && localState && localState.localStore && localState.localStore.dmsSecurityTokenKey) {
        return axios.post(requestUrl,
            data,
            {
                headers: { ...commonHeaders }
            }).then((response) => {
                const responseObj = handleResponseStatus(response);

                if (responseObj.IsSuccess) {
                    return Promise.resolve(responseObj);
                }
                else {
                    if (responseObj && responseObj.data.Code === Constants.DMS_SESSION_EXPIRED && !isSessionExpired && dispatchInstance !== null) {
                        /* True the isSessionExpired variable to break all the tasks */
                        isSessionExpired = true;

                        /* Show alert and redirect to login page */
                        dispatchInstance(handleAppForceLogout(Constants.RA_SESSION_EXPIRED));

                        setTimeout(() => { isSessionExpired = false }, 1500);
                    }

                    return Promise.reject(responseObj);
                }
            });
    }
    else if (!isSessionExpired) {
        if (dispatchInstance !== null) {
            /* Reload the page when no app data available after login with message */
            dispatchInstance(handleNoAppData());
        }
        else {
            /* Reload the page when no app data available before login */
            window.location = window.location.origin;
        }
    }
};

/* Handle Success Fail HTTP request */
const handleResponseStatus = response => {
    if (response && response.data.Response && response.data.Response !== "0") {
        /* Override the response object */
        response.IsSuccess = true;

        return response;
    }
    else {
        /* Override the response object */
        response.IsSuccess = false;
        response.data.Code = response.data.ErrorCode;
        response.data.Msg = response.data.ErrorMsg;

        return response;
    }
};

/* Handle Success Fail HTTP request */
const handleTokenResponseStatus = response => {
    if (response && response.status === 200)
        return true;
    else
        return false;
};

/* Get common header to make HTTP request */
const getCommonHeaders = (needToken) => {
    const localState = loadState();
    if (needToken && localState && localState.localStore && localState.localStore.dmsSecurityTokenKey) {
        const accessSecurityTokenKey = localState.localStore.dmsSecurityTokenKey;

        return {
            "Content-Type": "application/json",
            [dmsSecurityTokenKey]: accessSecurityTokenKey
        };
    }
    else {
        return {
            "Content-Type": "application/x-www-form-urlencoded"
        };
    }
};